/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */

import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form/immutable';
import AlpsUpdateVersionForm from './layout';
import { formValidation } from '../validation';
import { getSelectedSubEntityId } from '../../../../redux/modules/entities/selectors';
import { subEntityFormSubmission } from '../../../../redux/modules/form/selectors';
import { entitiesMetaData } from '../../../../redux/modules/entities/metaData';
import { setSelectedSubEntityId } from '../../../../redux/modules/entities';
import {
  selectViewVersionFormInitialValues,
  formTypeHasSubtypes,
  selectSubTypeLabelText,
  selectTypeLabelText
} from '../../../../redux/modules/entities/alps/selectors';

const CreateAlpsUpdateVersionForm = compose(
  connect((state) => ({
    form: `alpsUpdateVersion:${getSelectedSubEntityId(state)}`,
  })),
  reduxForm({
    onSubmit: subEntityFormSubmission,
    validate: formValidation,
    destroyOnUnmount: true,
  })
)(AlpsUpdateVersionForm);

export function mapStateToProps(state) {
  let initialValues = selectViewVersionFormInitialValues(state);
  return {
    initialValues: initialValues,
    actionTypes: entitiesMetaData.alps.actionTypes,
    key: getSelectedSubEntityId(state),
    artifactTypeName:selectTypeLabelText(state),
    artifactSubtype:selectSubTypeLabelText(state),
    typeHasSubtypes: formTypeHasSubtypes(state),
  };
}

export const actions = {
  setSelectedSubEntityId,
};

export default connect(mapStateToProps, actions)(CreateAlpsUpdateVersionForm);
